import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import IconButton from 'components/common/IconButton';
import Menu, { MenuItem } from 'components/common/Menu';
import DeleteMenu from 'components/common/DeleteMenu';
import IconMoreVert from 'components/icons/IconMoreVert';
import InventoryWarehouseCreateEditDialog from 'components/settings/InventoryWarehouseCreateEditDialog';
import Link from 'components/common/Link';

import splitLongWords from 'utils/splitLongWords';

import { deleteInventoryWarehouse } from 'redux/modules/inventoryWarehouses';

const styles = () => ({
  iconMoreVert: {
    width: 24,
    height: 24,
  },
  buttonCell: {
    textAlign: 'right',
    padding: '0 10px 0 0',
    '&:last-child': {
      padding: '0 10px 0 0',
    },
  },
  cellPhone: {
    whiteSpace: 'nowrap',
  },
});

class InventoryWarehousesTableRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      deleteMenuOpen: false,
      editDialogOpen: false,
    };

    this.onMenuButtonClick = this.onMenuButtonClick.bind(this);
    this.onMenuClose = this.onMenuClose.bind(this);
    this.onDeleteMenuItemClick = this.onDeleteMenuItemClick.bind(this);
    this.onDeleteCancel = this.onDeleteCancel.bind(this);
    this.onDeleteSubmit = this.onDeleteSubmit.bind(this);
    this.onEditMenuItemClick = this.onEditMenuItemClick.bind(this);
    this.onEditDialogClose = this.onEditDialogClose.bind(this);
  }

  onMenuButtonClick(event) {
    this.setState({
      anchorEl: event.currentTarget,
      deleteMenuOpen: false,
    });
  }

  onMenuClose() {
    this.setState({ anchorEl: null });
  }

  onEditMenuItemClick() {
    this.setState({
      anchorEl: null,
      editDialogOpen: true,
    });
  }

  onDeleteMenuItemClick() {
    this.setState({ deleteMenuOpen: true });
  }

  onDeleteCancel() {
    this.setState({ anchorEl: null });
  }

  onDeleteSubmit() {
    const { ID, actions } = this.props;
    actions.deleteInventoryWarehouse({ ID });
    this.setState({
      deleteMenuOpen: false,
      anchorEl: null,
    });
  }

  onEditDialogClose() {
    this.setState({ editDialogOpen: false });
  }

  render() {
    const { account, Location, classes } = this.props;
    const { anchorEl, deleteMenuOpen, editDialogOpen } = this.state;
    const open = Boolean(anchorEl);

    return (
      <TableRow>
        <TableCell>
          <Link
            breakWord
            onClick={this.onEditMenuItemClick}
          >
            {splitLongWords(Location)}
          </Link>
        </TableCell>
        <TableCell>
          {this.props['Create At']}
        </TableCell>
        <TableCell className={classes.buttonCell}>
          <IconButton
            aria-label="More"
            aria-owns={open ? `${this.props.ID}-inventory-category-menu` : null}
            aria-haspopup="true"
            onClick={this.onMenuButtonClick}
            tooltipContent="Open Menu"
          >
            <IconMoreVert className={classes.iconMoreVert} />
          </IconButton>
          <Menu
            id={`${this.props.ID}-inventory-category-menu`}
            anchorEl={anchorEl}
            open={open}
            onClose={this.onMenuClose}
            list={!deleteMenuOpen}
            maxHeight={130}
          >
            {deleteMenuOpen ? (
              <DeleteMenu
                text="Are you sure you want to delete this inventory category?"
                onCancel={this.onDeleteCancel}
                onSubmit={this.onDeleteSubmit}
              />
            ) : (
              <Fragment>
                <MenuItem onClick={this.onEditMenuItemClick}>
                  Edit
                </MenuItem>
                <MenuItem
                  onClick={this.onDeleteMenuItemClick}
                  color="warning"
                  disabled={account.Roles.filter(item =>
                    item.Name === 'Master Administrator' || item.Name === 'Administrator' || item.Name === 'Manager').length === 0}
                >
                  Delete
                </MenuItem>
              </Fragment>
            )}
          </Menu>
        </TableCell>
        <InventoryWarehouseCreateEditDialog
          form={`inventoryWarehouseEdit-${this.props.ID}`}
          open={editDialogOpen}
          ID={this.props.ID}
          initialValues={{
            Location,
          }}
          onClose={this.onEditDialogClose}
          onSubmitSuccess={this.onEditDialogClose}
        />
      </TableRow>
    );
  }
}

InventoryWarehousesTableRow.propTypes = {
  ID: PropTypes.number.isRequired,
  Location: PropTypes.string.isRequired,
  'Create At': PropTypes.string.isRequired,
  actions: PropTypes.shape({
    deleteInventoryWarehouse: PropTypes.func.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    Roles: PropTypes.arrayOf(PropTypes.shape({
      Name: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    iconMoreVert: PropTypes.string.isRequired,
    buttonCell: PropTypes.string.isRequired,
    cellPhone: PropTypes.string.isRequired,
  }).isRequired,
};

InventoryWarehousesTableRow.defaultProps = {
  'Contact Person': null,
  'Mobile Phone': null,
  Email: null,
};

const mapStateToProps = store => ({
  account: store.account,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ deleteInventoryWarehouse }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(InventoryWarehousesTableRow),
);



// WEBPACK FOOTER //
// ./src/components/settings/InventoryWarehousesTable/InventoryWarehousesTableRow.js